import { IMAGES } from "@/lib/site-data";
import { ShieldCheck, Users, Award, Clock, Target, Sparkles } from "lucide-react";

export default function About() {
  return (
    <div className="bg-white">
      <section className="bg-sky-50/60 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold tracking-widest text-[#1e5ba8]">ABOUT EXIMXPRESS</p>
          <h1 className="font-display font-bold text-5xl sm:text-6xl text-[#0f172a] mt-3 tracking-tight">India&apos;s Reliable Onion Export Partner</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid lg:grid-cols-2 gap-12 items-center">
        <img src={IMAGES.onionBasket} alt="About" className="rounded-2xl w-full h-[460px] object-cover shadow-lg" />
        <div>
          <h2 className="font-display font-bold text-3xl text-[#1e5ba8] mb-4">Our Story</h2>
          <p className="text-slate-600 leading-relaxed">
            At EXIMXPRESS, we are committed to exporting the finest quality onions that meet international standards. Our advanced sorting, grading, packing and cold storage facilities ensure that every onion we deliver reaches you fresh, safe and full of goodness.
          </p>
          <p className="text-slate-600 leading-relaxed mt-4">
            With years of experience in the export industry, we have built long-lasting relationships with farmers, packers and importers across 30+ countries worldwide.
          </p>
          <div className="grid grid-cols-2 gap-4 mt-8">
            {[
              { icon: Target, title: "Our Mission", desc: "Deliver farm-fresh Indian onions with unmatched quality and reliability." },
              { icon: Sparkles, title: "Our Vision", desc: "Be the most trusted onion export brand globally." },
            ].map((i) => (
              <div key={i.title} className="p-5 border border-slate-200 rounded-xl">
                <i.icon className="w-6 h-6 text-[#1e5ba8]" />
                <div className="font-display font-bold mt-3 text-[#0f172a]">{i.title}</div>
                <div className="text-sm text-slate-600 mt-1">{i.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-50/70 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-center text-[#0f172a] mb-10">Our Core Values</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { icon: ShieldCheck, label: "Quality Assured" },
              { icon: Users, label: "Customer Focused" },
              { icon: Award, label: "Ethical Business" },
              { icon: Clock, label: "Timely Delivery" },
            ].map((v) => (
              <div key={v.label} className="bg-white p-6 rounded-xl border border-slate-200 flex flex-col items-center text-center gap-3 hover:-translate-y-1 transition-transform duration-200">
                <div className="w-14 h-14 rounded-full bg-[#1e5ba8] text-white flex items-center justify-center">
                  <v.icon className="w-6 h-6" />
                </div>
                <div className="font-semibold text-slate-800">{v.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
